import React, { useCallback, useLayoutEffect, useState } from "react";
export const useHover = (ref: React.RefObject<HTMLElement | null>) => {
  const [isHover, setIsHover] = useState(false);
  const handleMouseOver = useCallback(() => {
    setIsHover(true);
  }, []);
  const handleMouseOut = useCallback(() => {
    setIsHover(false);
  }, []);

  useLayoutEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener("mouseover", handleMouseOver);
      node.addEventListener("mouseout", handleMouseOut);
    }
    return () => {
      if (node) {
        node.removeEventListener("mouseover", handleMouseOver);
        node.removeEventListener("mouseout", handleMouseOut);
      }
    };
  }, [handleMouseOut, handleMouseOver, ref]);

  return isHover;
};
